module.exports = __webpack_public_path__ + "static/img/08.e8ef00c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/08.jpg
// module id = 19e9
// module chunks = 0